import React from "react";
import Dashboard from "./components/Dashboard";

export default function GeneralDashboardSM() {
  return <Dashboard programId={2} name="SM" />;
}
